// extracted by mini-css-extract-plugin
module.exports = {"paginator":"paginator--3k1a5","paginator__item":"paginator__item--183Vh","paginator__icon":"paginator__icon--3e2Fw","selected":"selected--2hinZ"};